import React, { Component } from "react";
import instance from "../../axios";
import Loader from "../../Layout/Loader";
import { getCompanyById } from "../../Helpers";
import {
  BayanatDeliveryNoteMui,
  mapMonthlyInvoiceToDoc,
  mapManualInvoiceToDoc,
  isManualInvoiceCreation,
  printMuiDoc,
  fetchAccountTermsSetting,
  resolveContractNumber,
} from "../../Components/Documents";

let selectedInvoice = false;
let serverTimeZoneName = "";

const resolveTimezoneFromQuery = (raw) => {
  try {
    return decodeURIComponent((raw || "").split("&")[0]) || "Asia/Riyadh";
  } catch (e) {
    return (raw || "").split("&")[0] || "Asia/Riyadh";
  }
};

class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      data1: {},
      loader: false,
      company: null,
      didAutoPrint: false,
    };
  }

  componentWillMount() {
    const queryString = window.location.search;
    var res = queryString.split("?&token=");
    let invoiceId = res[1].split("&leasing=");
    let sz = invoiceId[1].split("&timezone=");
    selectedInvoice = sz[0] === "true" ? "leaseinvoices" : "invoices";
    serverTimeZoneName = resolveTimezoneFromQuery(sz[1]);

    this.setState({ loader: true }, () => {
      instance({
        method: "GET",
        url: `/api/${selectedInvoice}/${invoiceId[0]}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then(async (response) => {
          if (response?.companyId) {
            getCompanyById(response.companyId)
              .then((company) => this.setState({ company }))
              .catch((error) => console.error(error.message));
          }
          const cn = resolveContractNumber(response);
          const setting =
            (await fetchAccountTermsSetting(cn)) || response?.setting || null;
          this.setState({
            data1: { ...response, setting },
            loader: false,
          });
        })
        .catch((error) => {
          console.log("error ====", error);
          this.setState({ loader: false });
        });
    });
  }

  componentDidUpdate() {
    this.maybeAutoPrint();
  }

  replaceAmpersands(obj) {
    if (!obj || typeof obj !== "object") return;
    for (const prop in obj) {
      if (typeof obj[prop] === "string") {
        obj[prop] = obj[prop].replace(/amp;/g, "");
      } else if (typeof obj[prop] === "object" && obj[prop] !== null) {
        this.replaceAmpersands(obj[prop]);
      }
    }
  }

  buildDoc() {
    const { data1, company } = this.state;
    if (!data1 || !Object.keys(data1).length) return null;
    const data = data1;
    this.replaceAmpersands(data);
    if (isManualInvoiceCreation(data)) {
      return mapManualInvoiceToDoc(data, company, {
        timezone: serverTimeZoneName,
      });
    }
    return mapMonthlyInvoiceToDoc(data, company, {
      timezone: serverTimeZoneName,
    });
  }

  maybeAutoPrint() {
    const params = new URLSearchParams(window.location.search);
    const autoPrint = params.get("autoPrint");
    const { loader, data1, didAutoPrint } = this.state;
    if (
      loader ||
      !data1 ||
      !Object.keys(data1).length ||
      didAutoPrint ||
      !autoPrint
    ) {
      return;
    }
    this.setState({ didAutoPrint: true }, () => {
      const doc = this.buildDoc();
      printMuiDoc({ title: doc?.titleEn || "Tax Invoice" }).then(() => {
        window.onafterprint = () => {
          try {
            window.close();
          } catch (e) {
            // ignore
          }
        };
      });
    });
  }

  render() {
    const { loader, data1 } = this.state;
    if (loader || !data1 || !Object.keys(data1).length) {
      return <Loader component="filter" />;
    }
    return <BayanatDeliveryNoteMui doc={this.buildDoc()} />;
  }
}

export default Invoice;
